import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay, catchError } from 'rxjs/operators';
import { HisNavigationService } from '../base/his-navigation.service';
import { HisBackendService } from '../backend/his-backend.service';

export interface ImageData {
    src: string;
    name: string;
    alt: string;
    tag: string;
}

export interface ImageResponse {
    result: ImageData[];
    statusCode: number;
}

@Injectable( {
    providedIn: 'root'
} )
export class HisSummernoteService {
    private http = inject(HttpClient);

    private hisNavigationService = inject( HisNavigationService );
    private backendService = inject(HisBackendService);
    // URL des REST-Services, der die Bildpfade aus HISinOne/images/portal/ zurückliefert
    private apiUrl = '/api/v1/cs/sys/imagesList';
    // Cache-Observable, das den Response speichert
    private imageCache$: Observable<ImageResponse>;

    /**
   * Ruft die Bilddaten als JSON vom REST-Service ab.
   * Nutzt einen Cache, um wiederholte HTTP-Requests zu vermeiden.
   */
    public getImagesPaths(): Observable<ImageResponse> {
        if (!this.imageCache$){
            this.imageCache$ = this.backendService.getData( this.apiUrl );
        }
        return this.imageCache$;
    }
}